// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SEO_DESCRIPTION_STROLLERS_CHARTS = "\u017deb\u0159\u00ed\u010dky ko\u010d\u00e1rk\u016f podle hodnocen\u00ed a obl\u00edbenosti";
export const SEO_TITLE_STROLLERS_CHARTS = "\u017deb\u0159\u00ed\u010dky ko\u010d\u00e1rk\u016f";
export const STROLLERS_CHARTS_TITLE = "\u017deb\u0159\u00ed\u010dky ko\u010d\u00e1rk\u016f";
